import { FormControl, MenuItem, TextField } from "@material-ui/core";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root2: {
      minWidth: "150px",
      "& .MuiInputBase-input": {
        boxShadow: "none",
      },
      "& .MuiInputLabel-outlined": {
        transform: "translate(14px, 14px) scale(1)",
      },
      "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
        transform: "translate(14px, -6px) scale(1)",
      },
      "& .MuiSelect-icon": {
        top: "calc(50% - 8px)",
      },
      "& .MuiInputBase-root": {
        // height: '40px',
        fontSize: "1.2rem",
        fontWeight: "500",
        // [theme.breakpoints.up('xl')]: {
        //   fontSize: "1.6rem",
        // },
      },
      "& .MuiInputLabel-root": {
        fontSize: "1.2rem",
        // [theme.breakpoints.up('xl')]: {
        //   fontSize: "1.6rem",
        // },
      },
      "& .MuiOutlinedInput-input": {
        padding: "16px 14px",
      },
      "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
        fontSize: "1.2rem",
        // [theme.breakpoints.up('xl')]: {
        //   fontSize: "1.6rem",
        // },
      },
    },
    root: {
      minWidth: "300px",
      "& .MuiInputBase-input": {
        boxShadow: "none",
      },
      "& .MuiInputLabel-outlined": {
        transform: "translate(14px, 14px) scale(1)",
      },
      "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
        transform: "translate(14px, -6px) scale(1)",
      },
      "& .MuiSelect-icon": {
        top: "calc(50% - 8px)",
      },
      "& .MuiInputBase-root": {
        // height: '40px',
        fontSize: "1.2rem",
        fontWeight: "500",
        // [theme.breakpoints.up('xl')]: {
        //   fontSize: "1.6rem",
        // },
      },
      "& .MuiInputLabel-root": {
        fontSize: "1.2rem",
        // [theme.breakpoints.up('xl')]: {
        //   fontSize: "1.6rem",
        // },
      },
      "& .MuiOutlinedInput-input": {
        padding: "16px 14px",
      },
      "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
        fontSize: "1.2rem",
        // [theme.breakpoints.up('xl')]: {
        //   fontSize: "1.6rem",
        // },
      },
    },
    option: {
      "&.MuiListItem-root": {
        fontSize: "1.2rem",
        // [theme.breakpoints.up('xl')]: {
        //   fontSize: "1.6rem",
        // },
      },
    },
    "@media (max-width: 600px)": {
      root: {
        minWidth: "250px",
      },
    },
  })
);

interface SelectFieldTypes {
  value?: string | number | null;
  defaultValue?: string | number;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  variant?: "outlined" | "filled" | "standard";
  id?: string;
  name?: string;
  label: string;
  choices?: Array<{ value: any; label: string; description?: string }> | null;
  noData?: string;
  fullWidth?: boolean;
  style?: any;
  disabled?: boolean;
  type?: string;
}

export const Select = ({
  value,
  onChange,
  variant,
  id,
  name,
  label,
  choices,
  noData,
  fullWidth,
  defaultValue,
  style,
  disabled,
  type = "",
}: SelectFieldTypes) => {
  const classes = useStyles();

  return (
    <FormControl variant="standard" fullWidth={fullWidth} style={style}>
      <TextField
        fullWidth={fullWidth}
        className={type === "mainSelect" ? classes.root2 : classes.root}
        id={id}
        name={name}
        inputProps={{ style: { minHeight: "inherit" } }}
        select
        label={label}
        value={value}
        defaultValue={defaultValue}
        onChange={onChange}
        variant="standard"
        disabled={disabled}
      >
        {choices ? (
          choices.map((choice) => (
            <MenuItem
              key={choice.value}
              value={choice.value}
              className={classes.option}
            >
              {choice.description} ({choice.label})
            </MenuItem>
          ))
        ) : (
          <MenuItem value="" className={classes.option}></MenuItem>
        )}
      </TextField>
    </FormControl>
  );
};
